"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var DataRow = function (props) {
    var _a = props.horizontal, horizontal = _a === void 0 ? false : _a, _b = props.dropBorder, dropBorder = _b === void 0 ? false : _b, dusk = props.dusk, flush = props.flush, className = props.className, placeholder = props.placeholder, label = props.label, value = props.value, icon = props.icon, squash = props.squash, unsafe = props.unsafe;
    return (react_1.default.createElement("div", { className: classnames_1.default({
            'border-b-3 border-gray-light': !dropBorder,
            'mb-6': !flush && !horizontal,
            'flex py-6': horizontal,
            'pb-6': !horizontal,
        }, className), "data-dusk": dusk },
        label && (react_1.default.createElement("div", { className: classnames_1.default({
                'w-2/5 flex-none': horizontal,
                'mb-3': !horizontal,
            }) },
            react_1.default.createElement("div", { className: classnames_1.default({
                    'inline-flex font-medium text-gray-dark items-center': true,
                }) },
                icon && react_1.default.createElement("div", { className: "pr-3" }, icon),
                react_1.default.createElement("span", null, label)))),
        react_1.default.createElement("div", { "data-dusk": dusk ? dusk + "-value" : null },
            value && (react_1.default.createElement("div", { className: classnames_1.default({
                    'pl-32': horizontal && !squash,
                    'pl-6': horizontal && squash,
                }) }, unsafe ? (react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: "" + value } })) : (react_1.default.createElement("span", null, value)))),
            !value && placeholder && react_1.default.createElement("div", { className: "text-gray" }, placeholder))));
};
exports.default = DataRow;
//# sourceMappingURL=index.js.map